import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import BankActionsTable from "./BankActionsTable";
import BankactionsDeleteModal from "./BankactionsDeleteModal";
import BankActionsHelpModal from "./BankActionsHelpModal";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const BankActionsPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  const [t] = useTranslation("global");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.PermissionNotDefined, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          {/*
           * Two surfaces author the same action_banks rows: this screen and
           * the setup wizard's Actions step. They diverged far enough that
           * this one's writes stopped reaching the server at all, so it is
           * being retired in favour of the wizard step, which also reports
           * whether a saved action actually became a button. The notice is
           * deliberately not a block: this screen still works, and removing
           * it before parity is demonstrated would strand anyone mid-task.
           */}
          <Alert
            type="info"
            showIcon
            className="generalStyles__mbFix"
            message={t("edgeManagement.banks.actionsDeprecatedTitle")}
            description={t("edgeManagement.banks.actionsDeprecatedBody")}
          />
          <BankActionsTable />
          <BankactionsDeleteModal />
          <BankActionsHelpModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default BankActionsPage;
